import { Image as TiptapImage } from '@tiptap/extension-image'
import { mergeAttributes } from '@tiptap/react'
import { ReactNodeViewRenderer } from '@tiptap/react'

import { ImageViewBlock } from './components/image-view-block'

export const Image = TiptapImage.extend({
    inline: true,
    group: 'inline',

    addNodeView() {
        return ReactNodeViewRenderer(ImageViewBlock, { as: 'span' })
    },

    renderHTML({ HTMLAttributes }: { HTMLAttributes: Record<string, string> }) {
        const { width, ...rest } = HTMLAttributes
        const attrs = width
            ? mergeAttributes(rest, { width, style: `width: ${width}px` })
            : mergeAttributes(rest)
        return ['img', attrs]
    },
})
